require("!!C:\\svn\\10.2.0\\node_modules\\script-loader\\addScript.js")(require("!!C:\\svn\\10.2.0\\node_modules\\raw-loader\\index.js!C:\\svn\\10.2.0\\node_modules\\uglify-loader\\index.js!C:\\svn\\10.2.0\\node_modules\\babel-loader\\lib\\index.js?{\"presets\":[\"react\",\"es2015\"],\"plugins\":[\"transform-class-properties\",\"transform-object-assign\"],\"compact\":false}!C:\\svn\\10.2.0\\bower_components\\dragtable\\jquery.dragtable.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/uglify-loader!./bower_components/dragtable/jquery.dragtable.js
// module id = 96
// module chunks = 0